var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',{staticClass:"flex-column justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.$vuetify.theme.themes.light.primary}})],1),_c('div',{staticClass:"main-card-text text-center text-body-1"},[_vm._v(" "+_vm._s(this.$store.state.progressMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }